var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-left"},[_c('h2',{staticClass:"title is-4"},[_vm._v("How is speed calculated?")]),_c('Message',[_vm._v(" Under construction! ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }